import React from 'react'
import PropTypes from 'prop-types'
import { CreateAccountPost } from 'guest-payment'
import $ from 'jquery'

import AppActions from '../actions/AppActions'
import AppStore from '../stores/AppStore';

import * as FPT from '../utility/fpt'

const STYLES = {
    logo:{
        width: '30px',
        height: '35px',
        marginBottom: '20px'
    },
    closeCrossHolder:{
        marginTop: '15px'
    },
    closeCross:{
        fontSize: '24px',
        cursor: 'pointer'
    },
	modal: {
        background: 'white'
	},
    createline1: {
        fontSize: 15,
        marginBottom: 0,
        fontFamily: 'pp-sans-big-medium'
    },
    createline2: {
        fontSize: 15,
        fontFamily: 'pp-sans-big-medium'
    },
    createline3: {
        margin: '0 auto',
        fontSize: 15,
        color: '#6c7378',
        maxWidth: '340px',
        width: '100%',
    },
    prefillEmail:{},
    emailInput: {
        background: 'white',
    },
    notNow:{
        marginTop: '10px'
    }
}

class SignUpPanel extends React.Component {
	constructor() {
		super();
		const confirmationData = AppStore.getConfirmation() || {}
		this.state = {
			isOfacPending: confirmationData.isOfacPending
		};
	}

	handleSignUp(password) {
        $('.spinneroverlay').show();

        FPT.trackLinkClick('createAccount');

        $.post('/donate/guest/upgrade', {
            email: AppStore.getEmail(),
            password: password
        }).then((response) => {
            let confirmationData = response.data.confirmationData || {}
            AppActions.updateConfirmation({ confirmation: confirmationData });
        }).always((response) => {
            $('.spinneroverlay').hide()
            this.handleContinue()
        })
	}

    handleContinue = () => {
        $('#guestCreateAccountdialog').modal('hide')
        if (this.state.isOfacPending) {
            this.context.router.push('/donate/guest/pending')
        } else {
            this.context.router.push('/donate/guest/confirmation')
        }
    }

	render () {
		return (
            <div className="modal fade guestCreateAccountdialog"
                style={STYLES.modal}
          		tabIndex="-1"
          		role="dialog"
          		id="guestCreateAccountdialog"
          		data-backdrop="static">
                <div className="col-xs-12 col-sm-12 col-md-12 text-right" style={STYLES.closeCrossHolder}>
    			    <span className="icon icon-close-small"
                        style={STYLES.closeCross}
                        onClick={()=> this.handleContinue()}
                        aria-hidden="true">
                    </span>
    			</div>
            	<div className="modal-dialog">
                    <div className="modal-content">
                        <div className="text-center donateCreateAccountLogo">
                            <img style={STYLES.logo} src={this.props.pplogo} />
                        </div>
                		<div className="donateCreateAccountHeader">
                            <p className="text-center" style={STYLES.createline1}>{this.props.mainTitle1}</p>
                            <p className="text-center" style={STYLES.createline2}>{this.props.mainTitle2}</p>
                            <p className="text-center" style={STYLES.createline3}>{this.props.mainTitle3}</p>
                		</div>
                  	    <div className="donateCreateAccountPost password_fields" style={STYLES.donateCreateAccountPost}>
                            <div className="vx_form-group" style={STYLES.prefillEmail}>
                                <input className="form-control vx_form-control"
                                    type="emailPost"
                                    id="emailPost"
                                    name="emailPost"
                                    disabled="true"
                                    style={STYLES.emailInput}
                                    value={this.props.email} />
                            </div>
                            <CreateAccountPost {...this.props}
                                handleSubmit={(value)=> this.handleSignUp(value)}/>
                            <div className="text-center" id="notNowBtn" style={STYLES.notNow}>
                                <a href="#" onClick={this.handleContinue}>{this.props.notNow}</a>
                            </div>
                  	    </div>
              	    </div>
                </div>
            </div>
		);
	}
};

SignUpPanel.propTypes = {
	cancelurl: PropTypes.string
};
SignUpPanel.contextTypes = {
  router: PropTypes.object.isRequired
};

export default SignUpPanel;



// WEBPACK FOOTER //
// ./components/signUpPanel.js